<template>
  <v-container class="mt-5">
    <v-layout row wrap v-if="error" justify-space-around>
      <v-flex xs12 sm6 lg5>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-space-around>
      <v-flex xs12 sm6 lg5>
        <v-card>
          <v-card-text>
            <v-layout row wrap>
              <v-flex>
                <v-text-field
                  prepend-icon="mail"
                  :label="$t('email')"
                  v-model.trim="email"
                  disabled></v-text-field>
              </v-flex>
            </v-layout>
            <v-form ref="form" v-model="isValid" lazy-validation>
              <v-layout row wrap justify-space-between>
                <v-flex md5>
                  <v-autocomplete
                    prepend-icon="explore"
                    :label="$t('role')"
                    :items="roles"
                    item-text="name"
                    item-value="id"
                    v-model="role"
                    :rules="[rules.checkNullStr('role')]"
                    clearable
                    class="required_field"></v-autocomplete>
                </v-flex>
                <v-flex md6>
                  <v-text-field
                    prepend-icon="vpn_key"
                    :label="$t('referralNumber')"
                    v-if="role === '0' || role === '2'"
                    v-model.trim="referralNum"
                    :rules="[rules.checkNullStr('referralNumber')]"
                    class="required_field"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="role === '0'" justify-space-between>
                <v-flex md5>
                  <v-autocomplete
                    prepend-icon="mode"
                    clearable
                    name="Org"
                    :label="$t('mode')"
                    v-model="mode"
                    item-text="text"
                    item-value="value"
                    :rules="[rules.checkNullStr('mode')]"
                    :items="modes"
                  ></v-autocomplete>
                </v-flex>
                <v-flex v-if="mode !== 'label'" v-bind="{ md6: role === '0' }">
                  <v-text-field
                    prepend-icon="local_shipping"
                    :label="$t('warehouse')"
                    v-model.trim="warehouseName"
                    ref="warehouse"
                    >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="mode === 'label' && role === '0'">
                <v-flex>
                  <v-text-field
                    prepend-icon="apartment"
                    :label="$t('companyName')"
                    v-model.trim="companyName"
                    ref="companyName"
                    :rules="[rules.checkNullStr('companyName')]"
                    class="required_field">
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex>
                  <v-text-field
                    prepend-icon="person"
                    :label="$t('username')"
                    v-model.trim="name"
                    ref="name"
                    :error-messages="errorMsg"
                    :error="!isNameAvailable"
                    :rules="[rules.checkNullStr('username')]"
                    class="required_field"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="lock"
                    :label="$t('password')"
                    type="password"
                    v-model.trim="password"
                    :rules="[rules.checkNullStr('password'), rules.checkPasswordLength]"
                    class="required_field"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="lock"
                    :label="$t('confirmPassword')"
                    type="password"
                    v-model.trim="confirmPwd"
                    :rules="[rules.checkNullStr('confirmPassword'), rules.checkConfirmPwd, rules.checkPasswordLength]"
                    class="required_field"></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout align-baseline justify-space-between>
                <v-btn @click="clear">Clear</v-btn>
                <LoaderButton
                  :buttonText="$t('confirm')"
                  :promiseAwait="onFormSubmitted"
                  ></LoaderButton>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import LoaderButton from './LoaderButton'

export default {
  name: 'SignupContinue',
  components: {
    LoaderButton
  },
  data () {
    return {
      isValid: false,
      roles: [
        {
          id: '0',
          name: 'Organization'
        },
        {
          id: '1',
          name: 'Individual'
        },
        {
          id: '2',
          name: 'Warehouse'
        }
      ],
      role: '0',
      referralNum: null,
      name: null,
      isNameAvailable: true,
      timeoutId: null,
      email: null,
      errorMsg: [],
      password: null,
      confirmPwd: null,
      mode: 'label',
      companyName: '',
      rules: {
        checkNullStr: (name) => {
          return (value) => {
            return !value || value.length === 0 ? this.$t('fieldIsRequired', { fieldName: this.$t(name) }) : true
          }
        },
        checkPasswordLength: (value) => {
          return !value || value.length < 8 ? this.$t('passwordLength') : true
        },
        checkConfirmPwd: (value) => {
          return !value || value !== this.password ? this.$t('passwordNotMatch') : true
        }
      },
      warehouseName: null
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    modes () {
      const signupMode = this.$store.getters.signupMode
      const modes = [
        { text: this.$t('label'), value: 'label' },
        { text: this.$t('warehouse'), value: 'warehouse' }
      ]
      if (signupMode && signupMode !== 'label') {
        modes.push({ text: this.$t('warehouse'), value: 'warehouse' })
      }
      return modes
    }
  },
  mounted () {
    const url = new URL(location.href)
    this.email = url.searchParams.get('email') || ''
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        this.$router.push('/')
      }
    },
    name (value) {
      this.isNameAvailable = false
      clearTimeout(this.timeoutId)
      this.timeoutId = setTimeout(() => {
        this.$store.dispatch('checkNameAvailable', value.trim())
          .then(rtn => {
            if (rtn) {
              this.isNameAvailable = true
              this.errorMsg = []
            } else {
              this.errorMsg = 'This name has been used'
            }
          })
      }, 500)
    }
  },
  methods: {
    onFormSubmitted () {
      if (this.$refs.form.validate() && this.isNameAvailable) {
        let payload = {
          name: this.name.trim(),
          password: this.password,
          role: parseInt(this.role),
          referral: this.referralNum,
          warehouseName: this.warehouseName
        }
        if (payload.role === 0) {
          payload.mode = this.mode
          payload.companyName = this.companyName
          if (payload.mode === 'label') payload.warehouseName = ''
        }
        return this.$store.dispatch('finishEmailSignup', payload)
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignupContinue.vue